import { useHandler } from "@redotech/react-util/hook";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

interface InitialFeeModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (fee: number) => void;
}

export const InitialFeeModal = memo(function InitialFeeModal({
  open,
  onClose,
  onSubmit,
}: InitialFeeModalProps) {
  const [fee, setFee] = useState<string>("");

  const handleClose = useHandler(() => {
    setFee("");
    onClose();
  });

  const handleSubmit = useHandler(() => {
    const feeValue = parseFloat(fee);
    if (isNaN(feeValue) || feeValue < 0) {
      return;
    }
    onSubmit(feeValue);
    setFee("");
  });

  const isValidFee =
    fee !== "" && !isNaN(parseFloat(fee)) && parseFloat(fee) >= 0;

  return (
    <RedoModal
      isOpen={open}
      onModalCloseRequested={handleClose}
      primaryButton={{
        text: "Set Fee",
        onClick: handleSubmit,
        disabled: !isValidFee,
      }}
      secondaryButton={{ text: "Cancel", onClick: handleClose }}
      title="Set Monthly Subscription Fee"
    >
      <Flex dir="column" gap="lg">
        <Text fontSize="sm" textColor="secondary">
          Enter the monthly subscription fee for OMS.
        </Text>
        <RedoTextInput
          label="Monthly Fee ($)"
          placeholder="e.g., 99"
          setValue={setFee}
          value={fee}
        />
      </Flex>
    </RedoModal>
  );
});
